import './scss/style.scss';
// import './scss/_nav.scss';
import('./js/nav.js');
import { preloadImages  } from './js/utils.js';

// window.onbeforeunload = function () {
//   window.scrollTo(0, 0);
// }

preloadImages('img').then(() => {

// Get page url
const path = window.location.pathname;

//remove slash from page name
const page = path.replace(/\//g, "");

if(page != "") {
  document.body.classList.add(page + "-page");
}

if(page === "") {
    document.body.classList.add("front-page");
    import('./js/gallery.js');
}
	document.body.classList.remove('loading');
});


const aniEls = document.querySelectorAll('.ani');
function observerCallback(entries) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('ani-view');
    }
  });
}
const observer = new IntersectionObserver(observerCallback);
aniEls.forEach((el) => observer.observe(el));
    
